import { Component, Inject } from '@angular/core';
import { ISitemap, SITEMAP } from 'pbc.angular';
import { IFilterConfig, ISelection } from 'pbc.types';

import get from 'lodash/get';
import { Subscription } from 'rxjs';

import { IProfilResponse, ProfilQueryFilterConfig } from 'fa-kt.types';

import { ProfilService } from '../service';

@Component({
  selector: 'fa-kt-profil-filter',
  templateUrl: './profil-filter.component.html',
  styleUrls: ['./profil-filter.component.css'],
})
export class ProfilFilterComponent {
  readonly subscriptions: Subscription[] = [];

  public ProfilFilterConfig: IFilterConfig<IProfilResponse>;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public profil: ProfilService,
  ) {
    this.ProfilFilterConfig = ProfilQueryFilterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
    /* << update mapper    */
    /*    update mapper >> */
  }

  ngOnInit() {
    this.subscriptions.push();
  }

  ngOnDestroy() {
    this.subscriptions.forEach(($) => $.unsubscribe());
  }

  private shape(field: string, shapes: ISelection[]): void {
    const index = this.ProfilFilterConfig.findIndex((f) => f.key === field);
    if (index < 0) {
      return;
    }
    this.ProfilFilterConfig[index].selections = shapes;
  }
}
